/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { TechPhoneFaxIcon16Light } from './TechPhoneFaxIcon16Light';
import { TechPhoneFaxIcon16Regular } from './TechPhoneFaxIcon16Regular';
import { TechPhoneFaxIcon16Solid } from './TechPhoneFaxIcon16Solid';
import { TechPhoneFaxIcon20Light } from './TechPhoneFaxIcon20Light';
import { TechPhoneFaxIcon20Regular } from './TechPhoneFaxIcon20Regular';
import { TechPhoneFaxIcon20Solid } from './TechPhoneFaxIcon20Solid';
import { TechPhoneFaxIcon24Regular } from './TechPhoneFaxIcon24Regular';
import { TechPhoneFaxIcon24Solid } from './TechPhoneFaxIcon24Solid';
import { TechPhoneFaxIcon32Regular } from './TechPhoneFaxIcon32Regular';
import { TechPhoneFaxIcon64Regular } from './TechPhoneFaxIcon64Regular';
var sizes = {
    16: {
        light: TechPhoneFaxIcon16Light,
        regular: TechPhoneFaxIcon16Regular,
        solid: TechPhoneFaxIcon16Solid,
    },
    20: {
        light: TechPhoneFaxIcon20Light,
        regular: TechPhoneFaxIcon20Regular,
        solid: TechPhoneFaxIcon20Solid,
    },
    24: {
        regular: TechPhoneFaxIcon24Regular,
        solid: TechPhoneFaxIcon24Solid,
    },
    32: {
        regular: TechPhoneFaxIcon32Regular,
    },
    64: {
        regular: TechPhoneFaxIcon64Regular,
    },
};
export var TechPhoneFaxIcon = forwardRef('TechPhoneFaxIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
